import { ROLE_LADDER } from "./data/DiscordPageData";

export default function DiscordServerStructure() {
  return (
    <>
      {/* ── STRUCTURE ────────────────────────────────────────────── */}
      <section className="dsc-section" id="structure">
        <div className="dsc-eyebrow">Server Structure</div>
        <h2 className="dsc-h2">
          Built on <span className="hi">clear hierarchy</span>
        </h2>
        <p className="dsc-section-sub">
          Every member knows their place, their captain, and their mission. No
          chaos — just structured, purposeful collaboration at scale. Four
          roles, one ladder, and every step adds scope.
        </p>

        <div className="dsc-hier">
          {ROLE_LADDER.map((role) => (
            <div key={role.num}>
              <div className={`dsc-tier tone-${role.tone}`}>
                <div className="dsc-tier-num">
                  <img
                    src={role.image}
                    alt=""
                    loading="lazy"
                    className="dsc-tier-img"
                  />
                  <span className="dsc-tier-step">{role.num}</span>
                </div>
                <div>
                  <div className="dsc-tier-title">
                    {role.title}
                    <span className="dsc-tier-pill">{role.pill}</span>
                  </div>
                  <p className="dsc-tier-desc">{role.desc}</p>
                  <div className="dsc-chips">
                    {role.chips.map((c) => (
                      <span key={c} className="dsc-chip">
                        {c}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
              {role.connector && (
                <div className="dsc-connector">
                  <div className="dsc-cl" />
                  {role.connector}
                </div>
              )}
            </div>
          ))}
        </div>

        <p className="dsc-note">
          Above every Commander sit the <strong>Software Engineers</strong> —
          the core team who assign ongoing projects, allocate teams to
          Commanders, and approve every Team Captain → Project Captain
          promotion.
        </p>
      </section>
    </>
  );
}
